import { RepaymentFrequency } from "../../application/form/application-form.consts";

export const AUTOSAVE_DELAY = 3000;

export enum DebtType {
  CREDIT_CARD = "credit-card",
  PERSONAL_LOAN = "personal-loan",
  MORTGAGE = "mortgage",
}

export const FREQUENCY_OPTIONS = [
  { label: RepaymentFrequency.WEEKLY, value: RepaymentFrequency.WEEKLY },
  {
    label: RepaymentFrequency.FORTNIGHTLY,
    value: RepaymentFrequency.FORTNIGHTLY,
  },
  { label: RepaymentFrequency.MONTHLY, value: RepaymentFrequency.MONTHLY },
  { label: "Annually", value: RepaymentFrequency.ANNUAL },
];

export enum MaritalStatus {
  SINGLE = "Single",
  MARRIED = "Married",
  DE_FACTO = "De Facto",
  SEPARATED = "Separated",
  DIVORCED = "Divorced",
  WIDOWED = "Widowed",
  OTHER = "Other",
}

export const MARITAL_STATUS_OPTIONS = Object.values(MaritalStatus).map(
  (maritalStatus) => ({ label: maritalStatus, value: maritalStatus })
);
